import * as React from 'react';
import Popup, { IPopup } from './newPopup';
import styled from 'styled-components';
import { Input } from '../input/newInput/NewInput';

const WrapperInputAndFieldName = styled.div(
  ({ theme }) => `
      display: flex;
      justify-content: space-between;
      padding: 10px 0 10px 0;
      align-items: center;
`
);

const FieldName = styled.div(
  ({ theme }) => `
      font-size: 14px;
      font-weight: bold;
      color: ${theme.colors.black};
      padding: 0 20px 0 0;
      min-width: 180px;
      text-align: left;
`
);

const SPopup = styled(Popup)(
  ({}) => `
    height: 500px;
    width: 500px;
`
);

// @ts-ignore
export interface IInputData {
  value: string;
  error: string;
}

export interface IFieldList {
  fieldName: string;
  fieldLabel: string;
  inputData: IInputData;
}

interface IAddMemberPopupProps extends IPopup {
  fieldList: IFieldList[];
  handleMemberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddMemberPopup: React.FC<IAddMemberPopupProps> = (props: IAddMemberPopupProps) => {
  const {
    grayButtonText,
    grayButtonAction,
    blueButtonAction,
    blueButtonText,
    blueButtonImg,
    boldText,
    dataAt,
    fieldList,
    handleMemberChange,
  } = props;
  const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(true);

  const isDisabled = () => {
    let allFieldsAreSet: boolean = true;
    let allFieldsNoErrors: boolean = true;

    fieldList.map((field) => {
      if (!field.inputData.value) {
        allFieldsAreSet = false;
      }
      if (field.inputData.error) {
        allFieldsNoErrors = false;
      }
    });

    const isDisabled: boolean = !allFieldsNoErrors || !allFieldsAreSet;
    setIsSubmitDisabled(isDisabled);
  };

  React.useEffect(() => {
    isDisabled();
  }, [fieldList]);

  return (
    <SPopup
      grayButtonAction={grayButtonAction}
      blueButtonAction={blueButtonAction}
      grayButtonText={grayButtonText}
      blueButtonText={blueButtonText}
      isBlueButtonDisabled={isSubmitDisabled}
      blueButtonImg={blueButtonImg}
      boldText={boldText}
      dataAt={dataAt}
      expanded
    >
      {fieldList.map((item, key) => {
        return (
          <WrapperInputAndFieldName key={item.fieldName}>
            <FieldName>{item.fieldLabel}</FieldName>
            <Input {...item.inputData} name={item.fieldName} onChange={(e) => handleMemberChange(e)} />
          </WrapperInputAndFieldName>
        );
      })}
    </SPopup>
  );
};
